import { Component } from '@angular/core';

@Component({
  selector: 'app-event-configure-terms',
  templateUrl: './event-configure-terms.component.html'
})
export class EventConfigureTermsComponent { }
